import React from 'react';
import { TouchableOpacity } from 'react-native';

import { Text } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

// List-row action ("Add below", "Move up", "Remove"): 44 pt pill, two per row.
const PlanogramActionButton = ({
	label,
	onPress,
	disabled = false,
	isDanger = false,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<TouchableOpacity
			style={[styles.actionButton, isDanger && styles.actionButtonDanger, disabled && styles.actionButtonDisabled]}
			disabled={disabled}
			onPress={onPress}
			accessibilityRole="button"
			accessibilityState={{ disabled }}
		>
			<Text
				style={[
					styles.actionButtonText,
					isDanger && styles.actionButtonTextDanger,
					disabled && styles.actionButtonTextDisabled,
				]}
				numberOfLines={1}
			>
				{label}
			</Text>
		</TouchableOpacity>
	);
};

const createStyles = ({ ui: { colors, type, space, radius, touch } }) => ({
	actionButton: {
		flexGrow: 1,
		flexBasis: '40%',
		minHeight: touch.min,
		alignItems: 'center',
		justifyContent: 'center',
		paddingHorizontal: space.md,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		borderRadius: radius.pill,
		backgroundColor: colors.card,
	},
	actionButtonDanger: {
		borderColor: colors.dangerBorder,
		backgroundColor: colors.dangerBg,
	},
	actionButtonDisabled: {
		borderColor: colors.disabledBg,
		backgroundColor: colors.disabledBg,
	},
	actionButtonText: {
		...type.bodySmallStrong,
		color: colors.onChip,
	},
	actionButtonTextDanger: {
		color: colors.danger,
	},
	actionButtonTextDisabled: {
		color: colors.disabledText,
	},
});

export default PlanogramActionButton;
